import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialVideoMatonPage() {
    const navigate = useNavigate();
    const videoRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const [stream, setStream] = useState(null);
    const [recording, setRecording] = useState(false);
    const [videoBlob, setVideoBlob] = useState(null);
    const [countdown, setCountdown] = useState(0);

    // Initialiser la caméra
    useEffect(() => {
        async function enableStream() {
            try {
                const s = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
                setStream(s);
                if (videoRef.current) videoRef.current.srcObject = s;
            } catch (err) {
                console.error("Erreur caméra:", err);
                alert("Impossible d'accéder à la caméra.");
            }
        }
        enableStream();
        return () => {
            if (stream) stream.getTracks().forEach(track => track.stop());
        };
    }, []);

    const startRecording = () => {
        setCountdown(3);
        let count = 3;
        const timer = setInterval(() => {
            count--;
            setCountdown(count);
            if (count === 0) {
                clearInterval(timer);
                launchRecorder();
            }
        }, 1000);
    };

    const launchRecorder = () => {
        const chunks = [];
        const recorder = new MediaRecorder(stream);
        recorder.ondataavailable = e => chunks.push(e.data);
        recorder.onstop = () => {
            const blob = new Blob(chunks, { type: 'video/webm' });
            setVideoBlob(blob);
        };
        recorder.start();
        setRecording(true);
        mediaRecorderRef.current = recorder;
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setRecording(false);
        }
    };

    const handleShare = () => {
        // En vrai, on uploaderait le blob ou on utiliserait l'API Share
        alert('Vidéo générée ! Prête pour WhatsApp/Email 🚀');
        navigate('/commercial/launchpad');
    };

    const handleRetry = () => {
        setVideoBlob(null);
        if (videoRef.current) videoRef.current.srcObject = stream;
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: 'black', position: 'relative', overflow: 'hidden' }}>

            {/* Camera View */}
            {!videoBlob ? (
                <video
                    ref={videoRef} autoPlay playsInline muted
                    style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scaleX(-1)' }}
                />
            ) : (
                <video
                    src={URL.createObjectURL(videoBlob)} controls
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
            )}

            {/* Overlay Branding */}
            <div style={{ position: 'absolute', top: 20, left: 20, zIndex: 10, display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 40, height: 40, borderRadius: 8, background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', display: 'grid', placeItems: 'center', color: 'white', fontWeight: 900 }}>IC</div>
                <div style={{ color: 'white', fontWeight: 700, textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>InfoColab</div>
            </div>

            {/* Controls */}
            <div style={{ position: 'absolute', bottom: 40, left: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 30, zIndex: 20 }}>

                {videoBlob ? (
                    <>
                        <button onClick={handleRetry} style={{ padding: '15px 30px', borderRadius: 50, background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', fontSize: '1rem', cursor: 'pointer', backdropFilter: 'blur(5px)' }}>Recommencer</button>
                        <button onClick={handleShare} style={{ padding: '15px 30px', borderRadius: 50, background: '#10b981', border: 'none', color: 'white', fontSize: '1rem', fontWeight: 700, cursor: 'pointer', boxShadow: '0 5px 15px rgba(16, 185, 129, 0.4)' }}>Envoyer 🚀</button>
                    </>
                ) : (
                    <>
                        {recording ? (
                            <button onClick={stopRecording} style={{ width: 80, height: 80, borderRadius: '50%', border: '4px solid white', background: '#ef4444', cursor: 'pointer', display: 'grid', placeItems: 'center' }}>
                                <div style={{ width: 20, height: 20, background: 'white', borderRadius: 4 }} />
                            </button>
                        ) : (
                            countdown > 0 ? (
                                <div style={{ fontSize: '5rem', color: 'white', fontWeight: 900, textShadow: '0 4px 10px rgba(0,0,0,0.5)' }}>{countdown}</div>
                            ) : (
                                <button onClick={startRecording} style={{ width: 80, height: 80, borderRadius: '50%', border: '4px solid white', background: 'transparent', cursor: 'pointer', display: 'grid', placeItems: 'center' }}>
                                    <div style={{ width: 60, height: 60, borderRadius: '50%', background: '#ef4444' }} />
                                </button>
                            )
                        )}
                    </>
                )}
            </div>

            {/* Close */}
            <button
                onClick={() => navigate('/commercial/launchpad')}
                style={{ position: 'absolute', top: 20, right: 20, background: 'rgba(0,0,0,0.3)', color: 'white', border: 'none', width: 40, height: 40, borderRadius: '50%', cursor: 'pointer', zIndex: 10, fontSize: '1.2rem' }}
            >
                ✕
            </button>
        </div>
    );
}
